module.exports = __webpack_public_path__ + "static/media/lokal.2b286f77.svg";